import { Cell, Grid, Heading, HFlow, Icon, InfoLabel, Text } from 'bold-ui'
import { Color } from 'csstype'
import { formatDate } from 'util/date/formatDate'
import { isNumberInRange } from 'util/number/number-in-range'
import { useAcompanhamentoCondicaoSaudeContext } from 'view/acompanhamento/acompanhamento-condicao-saude/context/AcompanhamentoCondicaoSaudeContext'
import { IDADE_FORA_DE_RASTREIO_TEXT } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-saudeMulher'

import { ListaTematicaCidCiapUtilizadosInfoIcon } from '../../lista-tematica/ListaTematicaCidCiapUtilizadosInfoIcon'
import { RANGE_IDADE_RASTREIO_SAUDE_SEXUAL_REPRODUTIVA } from './constants-saudeMulher'

interface UltimaConsultaSaudeSexualReprodutivaPanelProps {
  data: LocalDate
  idadeCidadao: number
  iconColor: Color
}

export function UltimaConsultaSaudeSexualReprodutivaPanel(
  props: Readonly<UltimaConsultaSaudeSexualReprodutivaPanelProps>
) {
  const { data, idadeCidadao, iconColor } = props

  const { ciapsConsiderados, cidsConsiderados } = useAcompanhamentoCondicaoSaudeContext()

  const isInRange = isNumberInRange(idadeCidadao, RANGE_IDADE_RASTREIO_SAUDE_SEXUAL_REPRODUTIVA)

  return (
    <Grid gap={1} gapVertical={0.5} alignItems='baseline'>
      <Cell size={12}>
        <HFlow hSpacing={0.25} alignItems='center'>
          <Icon icon='nurse' size={1} color={iconColor} />
          <Heading level={4}>Acompanhamento de saúde sexual e reprodutiva</Heading>
          <ListaTematicaCidCiapUtilizadosInfoIcon
            cidsConsiderados={cidsConsiderados}
            ciapsConsiderados={ciapsConsiderados}
          />
        </HFlow>
      </Cell>
      <Cell size={12}>
        {isInRange ? (
          <InfoLabel title='Última consulta'>{formatDate(data)}</InfoLabel>
        ) : (
          <Text fontStyle='italic'>{IDADE_FORA_DE_RASTREIO_TEXT}</Text>
        )}
      </Cell>
    </Grid>
  )
}
